import styled from 'styled-components';

export const ListingCard = styled.div`
    border-radius: 1.2rem;
    background-color: #ffffff;
    margin-bottom: 1.2rem;  
    ${p => p.selectedItem &&`
        box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.5);
        border: solid 0.1rem #2276e3;
    `}  
`;

export const HrPackageCard = styled.div`
    border-radius: 1.2rem;
    background-color: #ffffff;
    margin-bottom: 1.2rem;  
    padding: 4px 10px;
`